import * as THREE from 'three'
import React, { forwardRef, useLayoutEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { useGLTF, Stage, Grid, OrbitControls, Environment } from '@react-three/drei'
import './styles.css';
import Header from '../../components/Header';
import emailjs from "@emailjs/browser";
import { EffectComposer, Bloom } from '@react-three/postprocessing'
import { easing } from 'maath'

function Kamdo(props) {
  const head = useRef()
  const stripe = useRef()
  const light = useRef()
  const { nodes, materials } = useGLTF('/s2wt_kamdo_industrial_divinities-transformed.glb')
  useFrame((state, delta) => {
    const t = (1 + Math.sin(state.clock.elapsedTime * 2)) / 2
    stripe.current.color.setRGB(1 + t * 10, 2, 20 + t * 50)
    easing.dampE(head.current.rotation, [0, state.pointer.x * (state.camera.position.z > 1 ? 1 : -1), 0], 0.4, delta)
    light.current.intensity = 1 + t * 2
  })
  return (
    <group {...props}>
      <mesh castShadow receiveShadow geometry={nodes.body001.geometry} material={materials.Body} />
      <group ref={head}>
        <mesh castShadow receiveShadow geometry={nodes.head001.geometry} material={materials.Head} />
        <mesh castShadow receiveShadow geometry={nodes.stripe001.geometry}>
          <meshBasicMaterial ref={stripe} toneMapped={false} />
          <pointLight ref={light} intensity={1} color={[10, 2, 5]} distance={2.5} />
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/s2wt_kamdo_industrial_divinities-transformed.glb')

export default function Contact(props) {
  const spaceman = useRef()
  const ship = useRef()
  const [name,setName] = useState('');
  const [email,setEmail] = useState('');
  const [message,setMessage] = useState('');

  const handleSubmit = () => {
    console.log('Name',name)
    console.log('Email',email)
    console.log('Message',message)

    emailjs
      .send(
        "service_e5ubphk",
        "template_7nycjvf",
        {
          from_name: name,
          to_name: "JavaScript Mastery",
          from_email: email,
          to_email: "sujata@jsmastery.pro",
          message: message,
        },
        "y3u8Wt6tEKAA25cXi"
      )
      .then(
        () => {
          alert("Thank you. I will get back to you as soon as possible.");
          setName('');
          setEmail('');
          setMessage('');
        },
        (error) => {
          console.error(error);

          alert("Ahh, something went wrong. Please try again.");
        }
      );
  };

  return (
    <>
    {props?.screen !== 'Home' ? (
    <Header title={'CONTACT'}/>
    ):null}
    {props?.screen === 'Home' ? (
    <div className="protfolio-text">
      <p>CONTACT US</p>
      <h1>Have queries about our services or an exciting project idea?<br/> We're here for you—don't hesitate to get in touch!</h1>
    </div>
    ):null}
    <div className='container'>
    <div className='canva'>
      <Canvas gl={{ logarithmicDepthBuffer: true }} shadows camera={{ position: [-15, 0, 10], fov: 25 }}>
        <fog attach="fog" args={['black', 15, 21.5]} />
        <Stage intensity={0.5} environment="city" adjustCamera={false}>
          <Kamdo rotation={[0, Math.PI, 0]} />
        </Stage>
        {/* <Grid renderOrder={-1} position={[0, -1.85, 0]} infiniteGrid cellSize={0.6} cellThickness={0.6} sectionSize={3.3} sectionThickness={1.5} sectionColor={[0.5, 0.5, 10]} fadeDistance={30} /> */}
        <OrbitControls autoRotate autoRotateSpeed={0.05} enableZoom={false} makeDefault minPolarAngle={Math.PI / 2} maxPolarAngle={Math.PI / 2} />
        <EffectComposer disableNormalPass>
          <Bloom luminanceThreshold={1} mipmapBlur />
        </EffectComposer>
        {/* <Environment background preset="sunset" blur={0.8} /> */}
      </Canvas>
    </div>
    <div className='contact'>
        <h1>GET IN TOUCH</h1>
        <h5>Your Name</h5>
        <input value={name} type='text' placeholder={`What's your good name?`} className='input' onChange={e => setName(e.target.value)}/>
        <h5>Your Email</h5>
        <input value={email} type='text' placeholder={`What's your email name?`} className='input' onChange={e => setEmail(e.target.value)}/>
        <h5>Your Message</h5>
        <textarea value={message} type='text' placeholder={`What you want say?`} multiple={true} className='message' onChange={e => setMessage(e.target.value)}/>
        <div onClick={() => handleSubmit()} className='send'>
            Send Message
        </div>
    </div>
    </div>
    </>
  )
}
